module.exports = __webpack_public_path__ + "img/lady-input.023534af.webp";